<template>
  <div class="resizable-sidebar" :style="{ width: width + 'px' }" :class="{ 'hidden': hidden }" ref="sidebarRef"> 
    <div class="toggle-sidebar-btn" @click="$emit('toggle')">
      <h6 class="p-2">订阅</h6>
      <span v-if="hidden">▶</span>
      <span v-else>◀</span>
    </div>


    
    <ul class="list-group">
      <li v-for="group in feedStore.treeGroups" :key="group.id" class="list-group-item">
        <strong @click="toggleGroup(group)" class="group-header">
          <span>{{ group.isOpen ? '[-]' : '[+]' }}</span> 
          {{ group.name }}
        </strong>

        <ul v-show="group.isOpen">
          <li v-for="node in feedStore.getNodesForGroup(group.id)" :key="node.id" class="tree-node" 
          :class="{ active: feedStore.selectedNode?.id === node.id }"
          @click="onSelectNode(node)">
            <img :src="'data:image/png;base64,' + node.siteIcon" alt="icon" />
            {{ node.siteName }} 
            <span class="node-count">{{ node.totalFeed }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { useFeedStore } from '@/stores/feedStore';

defineProps({
    width: {
        type: Number,
        default: 250
    },
    hidden: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['toggle', 'select-node']);

const feedStore = useFeedStore();

const toggleGroup = (group) => {
    if (group.isOpen) return;
    feedStore.treeGroups.forEach(g => g.isOpen = false);
    group.isOpen = true;
};

const onSelectNode = (node) => {
    feedStore.selectedNode = node;
    emit('select-node', node);
};
</script>

<script>
// Separate script block to handle the emit correctly if I can't use const emit
</script>

<style scoped>
@import '@/assets/styles/AppLayout.css';

.theme-toggle-container {
    padding: 8px 16px;
    border-bottom: 1px solid var(--border-color);
    background-color: var(--secondary-bg);
    display: flex;
    justify-content: center;
}

.theme-btn {
    width: 100%;
    padding: 6px;
    font-size: 0.85rem;
    background-color: var(--hover-bg);
    color: var(--text-primary);
    border: 1px solid var(--border-color);
}
.theme-btn:hover {
    background-color: var(--accent-color);
    color: white;
    border-color: var(--accent-color);
}
</style>
